export default [
	{
		path: '/jointeam/:id',
		name: 'joinTean',
		component: () => import('@/views/h5/join-team.vue'),
		meta: { title: '加入团队', keepAlive: true }
	},
	{
		path: '/join/team/success',
		name: 'joinTeanSuccess',
		component: () => import('@/views/h5/join-team-success.vue'),
		meta: { title: '下载APP' }
	}
]
